import { baseApi } from "../../redux/baseAPI";

export const tcmApi = baseApi.injectEndpoints({
  tagTypes: ["TcmListing"],
  endpoints: (builder) => ({
    getTcms: builder.query({
      query: (body) => {
        if (body?.pid){
            return {
                url: `/tcm/index.json`,
                method: "GET",
                params: body,
            };
        }
      },
      transformResponse: (response, meta, arg) => response.response,
      providesTags: (result) => {
        try {
          return result
            ? [
                ...(Array.isArray(result?.data) 
                  ? result.data.map(({ id }) => ({ type: "TcmListing", id }))
                  : []),
                { type: "TcmListing", id: "LIST" },
              ]
            : [{ type: "TcmListing", id: "LIST" }];
        } catch (error) {
          return [{ type: "TcmListing", id: "LIST" }];
        }
      },
    }),
    getTcmMeta: builder.query({
      query: (body) => {
        return {
          url: `/tcm/meta.json`,
          method: "GET",
          params: body,
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
    }),
  }),
});

export const {
  useGetTcmsQuery,
  useGetTcmMetaQuery,
} = tcmApi;
